/* eslint-disable no-param-reassign */
// Locale
export const setLocaleImplementation = (state, action) => {
  // eslint-disable-next-line no-param-reassign
  state.locale = action.payload;
  // eslint-disable-next-line no-param-reassign
  state.eventsData.locale = action.payload;
};

// Configuration type
export const setConfigurationTypeImplementation = (state, action) => {
  // eslint-disable-next-line no-param-reassign
  state.configurationType = action.payload;
};

// Snackbar
export const showSnackbarImplementation = (state, action) => {
  const { id, hideCTA, customMessage } = action.payload;

  // eslint-disable-next-line no-param-reassign
  state.snackbar = {
    show: true,
    id,
    hideCTA,
    customMessage
  };
};

export const closeSnackbarImplementation = (state, action) => {
  if (state.snackbar.id === action.payload) {
    // eslint-disable-next-line no-param-reassign
    state.snackbar = {
      show: false
    };
  }
};

// Popup
export const showMinimalPopupImplementation = (state, action) => {
  // eslint-disable-next-line no-param-reassign
  state.minimalPopup = {
    show: true,
    message: action.payload
  };
};

// Steps
export const setCurrentStepImplementation = (state, action) => {
  state.currentStep = action.payload;

  const { readOnlyMode } = state;
  if (readOnlyMode) {
    return;
  }
  // update it in the configuration
  const { configuration } = state;
  if (configuration && configuration.configData.configStatus !== "FINISHED") {
    configuration.configData.currentStepId = action.payload.id;
    // update the config status
    configuration.configData.configStatus = action.payload.status;
  } else {
    console.log("status = FINISHED OR configuration is null => setCurrentStep can't be done");
  }
};

// Full screen
export const setFullScreenImplementation = (state, action) => {
  state.fullScreen = action.payload;
};

export const setSessionIdFetchedImplementation = (state, action) => {
  state.sessionIdFetched = action.payload;
};

export const setIsNewSessionIdImplementation = (state, action) => {
  state.isNewSessionId = action.payload;
};

export const setSavedConfigurationsImplementation = (state, action) => {
  state.savedConfigurations = action.payload;
};

export const setUpdatingConfigurationImplementation = (state, action) => {
  state.updatingConfiguration = action.payload;
};
